import React from "react";
import { PerceptualCrossing } from "../examples/PerceptualCrossing";

export function Tutorial({ stage }) {
  const stageType = stage.get("type");
  
  let instructions = "";
  switch (stageType) {
    case "fixed":
      instructions = "Practice interacting with a stationary object. Move your mouse left and right to feel the object.";
      break;
    case "slow":
      instructions = "Now let's try it with a slow moving object.";
      break;
    case "fast":
      instructions = "Finally, lets try to track a faster moving object.";
      break;
  }

  return (
    <div className="h-full flex flex-col">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold mb-4">Tutorial: {stage.get("name")}</h2>
        <p className="text-lg">{instructions}</p>
      </div>
      <div className="flex-grow">
        <PerceptualCrossing tutorial={true} stageType={stageType} />
      </div>
    </div>
  );
}